import React from "react";
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";


export default function Navbar() {

  const { t, i18n } = useTranslation();

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (

    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <Link className="navbar-brand" to="/">
          The Healing Colors
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
            <li className="nav-item">
              {/* <NavLink className="nav-link" activeClassName="active" to="/about-us">
                About us 
              </NavLink> */}
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/instructions">
                {t('instructions')}
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/colors">
                The 12 Colors
              </NavLink>
            </li> */}

            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/make-test">
                {t('test')}
              </NavLink>
            </li>
          </ul>
          <img src={'es.png'} onClick={() => changeLanguage('es')} className="lang-btn mx-1 my-2" alt="es"></img>

          <img src={'it.png'} onClick={() => changeLanguage('it')} className="lang-btn mx-1 my-2" alt="it"></img>

          <img src={'uk.png'} onClick={() => changeLanguage('en')} className="lang-btn mx-1 my-2" alt="en"></img>
        </div>
      </nav>
    </div>


  );
}
